import script from "./TableHeaderRow.vue?vue&type=script&setup=true&lang=ts"
export * from "./TableHeaderRow.vue?vue&type=script&setup=true&lang=ts"

import "./TableHeaderRow.vue?vue&type=style&index=0&id=bc01bcd2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bc01bcd2"]])

export default __exports__